// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-summarized-table {\n  box-shadow: none !important;\n}\n.base-summarized-table .p-datatable .p-datatable-tbody tr:last-child .base-table-cell {\n  border: none !important;\n}\n.tx-table-header h5 {\n  font-size: 1.1rem;\n  color: #6f6f6f;\n  font-weight: 400;\n}\n.tx-table-header h5 span {\n  color: #000000;\n  font-weight: 600;\n}\n.base-table-outer .p-paginator {\n  padding: 1.45rem 0 !important;\n}", ""]);
// Exports
module.exports = exports;
